import { Link, LinkProps, useSearchParams, To } from 'react-router-dom';
import { AddIcon } from '@/assets';
import { Flex } from '@tremor/react';

type WithIcon = { icon: string; iconAltText: string };
type WithoutIcon = { icon?: never; iconAltText?: never };

type Props = LinkProps & { preserveSearchParams?: boolean } & (WithIcon | WithoutIcon);

export function OutlinedLink({
  children,
  className,
  icon,
  iconAltText,
  preserveSearchParams = true,
  to,
  ...rest
}: Props) {
  const [searchParams] = useSearchParams();
  let toInternal: To;
  if (typeof to === 'string') {
    toInternal = { pathname: to };
  } else {
    toInternal = to;
  }

  if (preserveSearchParams) {
    toInternal.search = toInternal.search
      ? toInternal.search
      : '' + searchParams.toString();
  }
  return (
    <Link
      to={toInternal}
      className={[
        className,
        'flex items-center justify-center px-4 py-1.5 gap-2 bg-transparent h-8 text-primary-default border-2 border-solid border-primary-default [&_p]:flex [&_p]:items-center [&_p]:justify-center rounded-xl',
      ].join(' ')}
      {...rest}
    >
      <Flex style={{ gap: '8px' }}>
        {icon ? <img src={AddIcon} alt={iconAltText} /> : null}
        {children}
      </Flex>
    </Link>
  );
}
